export const formatCurrency = price => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  })

  return formatter.format(price).replace(/\.00$/, '')
}
